<template>
  <div class="flex flex-col">
    <div class="flex flex-row gap-11 items-start">
      <img
        v-if="selectQuantity < 1"
        style="height: 70px"
        src="@/assets/orderTest/order-page/promoPanel/empty_box.svg" 
        alt="select box" 
      />
      <img
        v-if="selectQuantity < 2"
        style="height: 70px"
        src="@/assets/orderTest/order-page/promoPanel/empty_box.svg" 
        alt="select box" 
      />
      <div class="relative" v-if="selectQuantity < 3">
        <img
          style="height: 70px"
          src="@/assets/orderTest/order-page/promoPanel/empty_box.svg" 
          alt="select box" 
        />
        <p class="three-items-pricing">{{ anyThreePromoPrice }}</p>
      </div>
      <img
        v-if="selectQuantity < 4"
        style="height: 70px"
            src="@/assets/orderTest/order-page/promoPanel/empty_box.svg" 
            alt="select box" 
          />
      <div class="relative" v-if="selectQuantity < 5">
        <img
          style="height: 70px"
          src="@/assets/orderTest/order-page/promoPanel/1000box.svg" 
          alt="select box" 
        />
        <p class="five-items-pricing">{{ anyFivePromoPrice }}</p>
      </div>
      <div
        :class="[
          {'animate': startFireAnimation && (selectQuantity === 3 || selectQuantity === 5)},
          {'firework3': selectQuantity === 3},
          {'firework5': selectQuantity === 5},
        ]"
      >
      </div>
    </div>
    <!-- <div class="flex flex-col" v-if="selectQuantity >= 2">
      <p v-if="selectQuantity >= 3">Your unlock {{selectQuantity === 5 ? '5 for $1000' : '3 for $700'}} bundle!</p>
      <p v-if="selectQuantity<5">Choose {{ selectQuantity > 3 ? 5-selectQuantity : '1' }} 
        more tests to unlock {{ selectQuantity > 3 ? '5 for $1000' : '3 for $700' }} </p>
    </div> -->

  </div>
</template>
<script>
export default {
  props: {
    selectQuantity: {
      type: Number,
      default: 0
    },
    savedPrice: {
      type: Number,
      default: 0
    },
    anyThreePromoPrice: {
      type: Number,
      default: 0
    },
    anyFivePromoPrice: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      startFireAnimation: false
    };
  },
  watch: {
    savedPrice(newVal) {
      if(newVal > 0) {
        setTimeout(() => {
          this.startFireAnimation = true
        }, 1800); 
      } else {
        this.startFireAnimation = false
      }
    },
    startFireAnimation(newVal) {
      if(newVal) {
        setTimeout(() => {
          this.startFireAnimation = false
        }, 3500); 
      }
    }
  }
}
</script>
<style scoped>
.firework3 {
  position: absolute;
  left: 50px;
  width: 350px;
  height: 70px;
  background-repeat: no-repeat;
}

.firework5 {
  position: absolute;
  left: 50px;
  width: 550px;
  height: 70px;
  background-repeat: no-repeat;
}

.firework3.animate,.firework5.animate {
  background-image: 
    url("../../../../../assets/orderTest/order-page/promoPanel/star3.svg"),
    url("../../../../../assets/orderTest/order-page/promoPanel/star6.svg"),
    url("../../../../../assets/orderTest/order-page/promoPanel/star3.svg"),
    url("../../../../../assets/orderTest/order-page/promoPanel/star4.svg"),
    url("../../../../../assets/orderTest/order-page/promoPanel/star3.svg"),
    url("../../../../../assets/orderTest/order-page/promoPanel/star5.svg"),
    url("../../../../../assets/orderTest/order-page/promoPanel/star4.svg"),
    url("../../../../../assets/orderTest/order-page/promoPanel/dot1.svg"),
    url("../../../../../assets/orderTest/order-page/promoPanel/dot2.svg"),
    url("../../../../../assets/orderTest/order-page/promoPanel/star7.svg"),
    url("../../../../../assets/orderTest/order-page/promoPanel/star7.svg"),
    url("../../../../../assets/orderTest/order-page/promoPanel/dot4.svg"),
    url("../../../../../assets/orderTest/order-page/promoPanel/dot5.svg");

  background-position: 
    4% 80%,
    45% 10%,
    35% 70%,
    60% 90%,
    75% 80%,
    95% 70%,
    100% 100%, 
    90% 0%,
    50% 80%,
    20% 90%,
    30% 15%,
    20% 10%,
    0% 10%;
  background-size: 
    15% 15%,
    15% 15%,
    15% 15%,
    15% 15%,
    15% 15%,
    15% 15%,
    15% 15%, 
    6% 6%,
    5% 5%,
    8% 8%,
    10% 10%,
    8% 8%,
    6% 6%;
  animation: fadeOutElements 1s ease-in-out infinite;
}

@keyframes fadeOutElements {
  0% {
    opacity: 1;
  }
  14% {
    background-image: 
      url("../../../../../assets/orderTest/order-page/promoPanel/star3.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/star6.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/star3.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/star4.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/star3.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/star5.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/star4.svg"),
      none,
      none,
      url("../../../../../assets/orderTest/order-page/promoPanel/star7.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/star7.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/dot4.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/dot5.svg");
  }
  28% {
    background-image: 
      url("../../../../../assets/orderTest/order-page/promoPanel/star3.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/star6.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/star3.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/star4.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/star3.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/star5.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/star4.svg"),
      none,
      none,
      url("../../../../../assets/orderTest/order-page/promoPanel/star7.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/star7.svg"),
      none,
      url("../../../../../assets/orderTest/order-page/promoPanel/dot5.svg");
  }
  42% {
    background-image: 
      none,
      none,
      none,
      url("../../../../../assets/orderTest/order-page/promoPanel/star4.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/star3.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/star5.svg"),
      none,
      none,
      none,
      url("../../../../../assets/orderTest/order-page/promoPanel/star7.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/star7.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/dot4.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/dot5.svg");
  }
  56% {
    background-image: 
      none,
      none,
      none,
      none,
      url("../../../../../assets/orderTest/order-page/promoPanel/star3.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/star5.svg"),
      none,
      none,
      none,
      url("../../../../../assets/orderTest/order-page/promoPanel/star7.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/star7.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/dot4.svg"),
      none;
    }
  70% {
    background-image: 
      none,
      none,
      none,
      none,
      none,
      none,
      none,
      none,
      none,
      url("../../../../../assets/orderTest/order-page/promoPanel/star7.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/star7.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/dot4.svg"),
      none;
  }
  72% {
    background-image: 
      none,
      none,
      none,
      none,
      none,
      none,
      none,
      none,
      none,
      none,
      url("../../../../../assets/orderTest/order-page/promoPanel/star7.svg"),
      url("../../../../../assets/orderTest/order-page/promoPanel/dot4.svg"),
      none;
  }
  84% {
    background-image: 
      none,
      none,
      none,
      none,
      none,
      none,
      none,
      none,
      none,
      none,
      none,
      none,
      none,
  }
  100% {
    background-image: 
      none,
      none,
      none,
      none,
      none,
      none,
      none
      none,
      none,
      none,
      none,
      none,
      none,
  }
}

.three-items-pricing {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(180deg, #F15B2C 0%, #FFD600 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 21px;
}

.five-items-pricing {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(180deg, #F15B2C 0%, #FFD600 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 21px;
}
</style>